<template>
  <div id="app">
    <Numeric/>
  </div>
</template>

<script>
import Numeric from './components/Numeric.vue'

export default {
  name: 'app',
  components: {
    Numeric
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
